import React from 'react';
import { Link } from 'react-router-dom';
import './GetStartedSection.scss';

const GetStartedSection = () => {
  return (
    <div className="cv-landing-get-started-section">
      <h2>Get Started Now</h2>
      <div className="cv-landing-get-started-btns">
        <Link className="cv-sign-in-btn" to={'/login'}>
          Sign In
        </Link>
        <Link className="cv-get-started-btn" to={'/signup'}>
          Register
        </Link>
      </div>
    </div>
  );
};

export default GetStartedSection;
